import { __assign, __extends } from "tslib";
import { namespacedClassnames } from '../../common';
import * as React from 'react';
import { Tooltip } from '..';
import { TOOLTIP_CLOSE_TRANSITION_DELAY } from '../../common/popper-engine';
// declare var require: any;
// tslint:disable-next-line:no-var-requires
var RealPopover = require('react-popover/build').default;
export var PopoverOuterActionOrigin;
(function (PopoverOuterActionOrigin) {
    PopoverOuterActionOrigin[PopoverOuterActionOrigin["escape"] = 0] = "escape";
    PopoverOuterActionOrigin[PopoverOuterActionOrigin["scroll"] = 1] = "scroll";
    PopoverOuterActionOrigin[PopoverOuterActionOrigin["click"] = 2] = "click";
})(PopoverOuterActionOrigin || (PopoverOuterActionOrigin = {}));
var BasePopover = /** @class */ (function (_super) {
    __extends(BasePopover, _super);
    function BasePopover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hotkeyHandler = null;
        _this.lastScrollTop = null;
        _this.eventHandler = null;
        _this.state = {
            isPopoverOpen: false,
            isTooltipForceHidden: false,
        };
        _this.isUncontrolled = _this.props.isOpen === undefined;
        _this.handleKeyUp = function (e) {
            if ((_this.props.isOpen || _this.state.isPopoverOpen) && e.keyCode === 27) {
                _this.props.onOuterAction && _this.props.onOuterAction(undefined, PopoverOuterActionOrigin.escape);
                if (_this.isUncontrolled) {
                    _this.closePopover();
                }
            }
        };
        _this.handleScroll = function (event) {
            if (event.srcElement) {
                if ((_this.props.isOpen || _this.state.isPopoverOpen) && _this.lastScrollTop) {
                    if (Math.abs(_this.lastScrollTop - event.srcElement.scrollTop) > 20) {
                        _this.props.onOuterAction && _this.props.onOuterAction(undefined, PopoverOuterActionOrigin.scroll);
                        if (_this.isUncontrolled) {
                            _this.closePopover();
                        }
                    }
                }
                else {
                    _this.lastScrollTop = event.srcElement.scrollTop;
                }
            }
        };
        _this.onClickOuterAction = function (e) {
            _this.props.onOuterAction && _this.props.onOuterAction(e, PopoverOuterActionOrigin.click);
            if (_this.isUncontrolled) {
                _this.closePopover();
            }
        };
        _this.openPopover = function () {
            var props = _this.props;
            if (props.isOpen === undefined && !!props.tooltipText) {
                _this.setState({ isTooltipForceHidden: true }, function () {
                    setTimeout(function () {
                        _this.setState({ isPopoverOpen: true });
                    }, TOOLTIP_CLOSE_TRANSITION_DELAY);
                });
            }
            else {
                _this.setState({ isPopoverOpen: true, isTooltipForceHidden: false });
            }
        };
        _this.closePopover = function () {
            _this.setState({ isPopoverOpen: false, isTooltipForceHidden: false });
        };
        return _this;
    }
    BasePopover.prototype.componentWillMount = function () {
        try {
            if (document) {
                this.document = document;
            }
        }
        catch (e) {
            //
        }
    };
    BasePopover.prototype.componentDidMount = function () {
        if (this.props.triggerOuterOnEsc) {
            window.addEventListener('keyup', this.handleKeyUp);
        }
        if (this.props.triggerOuterOnScroll) {
            window.addEventListener('scroll', this.handleScroll, true);
        }
    };
    BasePopover.prototype.componentWillUnmount = function () {
        if (this.props.triggerOuterOnEsc) {
            window.removeEventListener('keyup', this.handleKeyUp);
        }
        if (this.props.triggerOuterOnScroll) {
            window.removeEventListener('scroll', this.handleScroll);
        }
    };
    BasePopover.prototype.componentDidCatch = function (e) {
        console.warn('Caught error in Popover.. No panic though', e);
        // we want more memory
        // Catches errors thrown by popver in tests since move to R16.
        // These errors probably always existed, and surfaced now as R16 unmounts
        // the entire dom tree when errors are not cought.
        // More info here: https://fb.me/react-error-boundaries
    };
    BasePopover.prototype.render = function () {
        var props = this.props;
        var preferPlace = props.preferPlace ? props.preferPlace : 'below';
        var classNames = namespacedClassnames(props.popoverType, { 'in-front': !!props.bringToFront }) + (props.className ? " ".concat(props.className) : '');
        var popoverProps = __assign(__assign({}, props), { preferPlace: preferPlace, enterExitTransitionDurationMs: 250 });
        var isUncontrolled = props.isOpen === undefined;
        var childrenBody = this.props.children;
        var renderChildren = props.isOpen === undefined && !!props.tooltipText ? (React.createElement(Tooltip, { forceHidden: this.state.isTooltipForceHidden, body: props.tooltipText }, childrenBody)) : childrenBody;
        var renderClickableChildren = (React.createElement("div", { className: namespacedClassnames('popover-clickable-body-container'), onClick: this.openPopover }, renderChildren));
        if (this.document) {
            return (React.createElement(RealPopover, __assign({}, popoverProps, { isOpen: isUncontrolled ? this.state.isPopoverOpen : this.props.isOpen, onOuterAction: this.onClickOuterAction, className: classNames, appendTarget: this.document.body }), isUncontrolled ? renderClickableChildren : renderChildren));
        }
        else {
            // popovers should not render if it's not mounted
            return childrenBody;
        }
    };
    return BasePopover;
}(React.Component));
export { BasePopover };
//# sourceMappingURL=base-popover.js.map